<template>
  <div>
    <HeaderGestion/>
    <SubHeader
    nombre="Datos personales"
    precedente ="Hola"/>
    <FormDatPerso/>
  </div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeader from '../components/SubHeader.vue'
import FormDatPerso from '../components/FormDatPerso.vue'
export default {
  components: { HeaderGestion, SubHeader, FormDatPerso },
  name: '',
  mounted () {
    // alertJoa()
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
